const isValidSearch = (search) => search.length >= 3;

const validateSearch = () => {
  const submitButton = document.getElementById('submit');
  const search = document.getElementById('search').value;

  if (isValidSearch(search)) {
    submitButton.removeAttribute('disabled');
    submitButton.classList.remove('disabled');
  } else {
    submitButton.setAttribute('disabled', 'disabled');
    submitButton.classList.add('disabled');
  }
};

export default validateSearch;
